import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AuthenticationService} from '@services/authentification.service';
import {Router} from '@angular/router';
import {environment} from '~/environments/environment';
import {AlertService} from '@services/alert.service';

// Erreur renvoyée pour tout 429 : les composants la comparent pour afficher leur propre message,
// et un écran qui affiche l'erreur telle quelle montre ce texte
export const TOO_MANY_REQUESTS = 'Trop de requêtes, réessayez dans quelques minutes.';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        public authenticationService: AuthenticationService,
        private alertService: AlertService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            // Consentement OAuth (MCP) : le composant a besoin du code HTTP et du corps ({error, error_description}) ;
            // un client inconnu (404) ne doit pas renvoyer vers la page 404 et un 401 ramène vers le login sans reload.
            if (request.url.startsWith(`${environment.apiUrl}oauth/client/`) || request.url === `${environment.apiUrl}app/oauth/authorize`) {
                return throwError(err);
            }
            if (err.status === 401) {
                if (this.authenticationService.currentUserToken !== '' && this.authenticationService.currentUserToken !== null) {
                    // auto logout if 401 response returned from api
                    this.authenticationService.logout();
                    location.reload();
                }
            } else if (err.status === 403 && err.error.message == "token_outdate") {
                this.authenticationService.logout();
                window.location.replace('/app/login?error=token');
                this.alertService.error('Un autre utilisateur s\'est connecté sur votre compte LyBox, vous avez été automatiquement déconnecté. Si vous n\'êtes pas à l\'origine de cette manoeuvre, nous vous conseillons de changer immédiatement votre mot de passe. En cas de problème, vous pouvez nous contacter à contact@lybox.fr', true);
                return throwError('token_outdate');
            } else if (err.status === 404) {
                // app/city/{code} : un code 'global' (Paris/Lyon/Marseille entiers) n'a pas de fiche, l'appelant gère le 404
                if (request.url !== `${environment.apiUrl}app/forgotPassword` && request.url !== `${environment.apiUrl}app/login`
                    && !request.url.startsWith(`${environment.apiUrl}app/city/`)) {
                    this.router.navigate(['404']);
                }
            } else if (err.status == 0 && request.url.includes(environment.apiUrl) && !request.url.includes('/ai') && !request.url.includes('/dpe/analyse')) {
                // Écran « chargement » + rechargement UNIQUEMENT quand c'est l'API LyBox qui ne répond plus.
                // Une ressource tierce bloquée (ex. images Wikipedia des villes) ne doit pas
                // déclencher l'écran plein page ni la boucle de rechargements.
                document.getElementById("mainLoader").classList.remove("d-none");
                setTimeout(function() {
                    location.reload();
                }, 10000);
            }

            // Analyses IA : le composant a besoin du code HTTP (402 crédits épuisés,
            // 403 abonnement requis) pour choisir le message et l'action à proposer.
            if (/\/ai$/.test(request.url) || /\/dpe\/analyse$/.test(request.url)) {
                return throwError(err);
            }

            // 429 : le corps varie selon la route (parfois un message technique en anglais)
            if (err.status === 429) {
                return throwError(TOO_MANY_REQUESTS);
            }

            let error = '';
            console.log(err);
            if (err.error && err.error.errors) {
                err.error.errors.forEach((txt) => {
                    error += txt.message;
                });
            } else if (err.error && err.error.message) {
                error = err.error.message;
            } else {
                error = err.statusText;
            }
            console.log(error);
            return throwError(error);
        }));
    }
}
